import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import memoizeOne from 'memoize-one';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { components } from 'react-select';
import Select from '../Select';
import CURRENCY_CODES from './currencyCodes';
var emojiContainerStyle = {
  display: 'flex',
  alignItems: 'center'
};
var emojiStyle = {
  display: 'inline-block',
  width: '18px'
};

var CustomCurrencySelect = function CustomCurrencySelect(_ref) {
  var value = _ref.value,
      flag = _ref.flag,
      label = _ref.label,
      displayFullName = _ref.displayFullName;
  return React.createElement("div", {
    style: emojiContainerStyle
  }, React.createElement("span", {
    style: emojiStyle,
    dangerouslySetInnerHTML: {
      __html: flag
    }
  }), "\xA0 ", displayFullName ? "".concat(label, " (").concat(value, ")") : value);
};

CustomCurrencySelect.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  displayFullName: PropTypes.bool,
  flag: PropTypes.node
};

var CurrencySelector =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CurrencySelector, _PureComponent);

  function CurrencySelector() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CurrencySelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CurrencySelector)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onChangeCurrency", function (currency) {
      var onChange = _this.props.onChange;
      onChange(currency);
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrencyCodes", memoizeOne(function (disabledCurrencies) {
      // This prevents every currency selector from making a copy of the list of currencies.
      // Because the common use case is to not disable currencies, most selectors will not copy the list.
      if (!disabledCurrencies || disabledCurrencies.length === 0) {
        return CURRENCY_CODES;
      }

      var disabledCurrencySet = new Set(disabledCurrencies); // eslint-disable-next-line no-confusing-arrow

      var currencies = CURRENCY_CODES.map(function (currency) {
        return disabledCurrencySet.has(currency.value) ? _objectSpread({}, currency, {
          disabled: true
        }) : currency;
      });
      return currencies;
    }));

    _defineProperty(_assertThisInitialized(_this), "getCurrencyValue", function (codeOptions) {
      var currency = _this.props.currency;

      if (Array.isArray(currency)) {
        return currency.map(function (selectedCurrency) {
          var currencyIdx = codeOptions.findIndex(function (option) {
            return option.value === selectedCurrency;
          });
          return codeOptions[currencyIdx];
        });
      }

      var currencyIdx = codeOptions.findIndex(function (option) {
        return option.value === currency;
      });
      return codeOptions[currencyIdx];
    });

    return _this;
  }

  _createClass(CurrencySelector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          clearable = _this$props.clearable,
          currency = _this$props.currency,
          disabled = _this$props.disabled,
          disabledCurrencies = _this$props.disabledCurrencies,
          displayFullName = _this$props.displayFullName,
          label = _this$props.label,
          required = _this$props.required,
          rest = _objectWithoutProperties(_this$props, ["className", "clearable", "currency", "disabled", "disabledCurrencies", "displayFullName", "label", "required"]);

      var currencyClassName = "currency-select ".concat(className);
      var currencyCodes = this.getCurrencyCodes(disabledCurrencies);
      return React.createElement(Select, _extends({
        required: required,
        label: label,
        disabled: disabled,
        className: currencyClassName // This is the v2+ way of handling custom styling for various parts of the select
        // The inline functions are done in order to pass displayFullName along for the display logic
        ,
        components: {
          Option: function Option(_ref2) {
            var data = _ref2.data,
                props = _objectWithoutProperties(_ref2, ["data"]);

            return React.createElement(components.Option, props, React.createElement(CustomCurrencySelect, _extends({}, data, {
              displayFullName: displayFullName
            })));
          },
          SingleValue: function SingleValue(_ref3) {
            var data = _ref3.data,
                props = _objectWithoutProperties(_ref3, ["data"]);

            return React.createElement(components.SingleValue, props, React.createElement(CustomCurrencySelect, _extends({}, data, {
              displayFullName: displayFullName
            })));
          },
          MultiValue: function MultiValue(_ref4) {
            var data = _ref4.data,
                props = _objectWithoutProperties(_ref4, ["data"]);

            return React.createElement(components.MultiValue, props, React.createElement(CustomCurrencySelect, _extends({}, data, {
              displayFullName: displayFullName
            })));
          }
        },
        isOptionDisabled: function isOptionDisabled(option) {
          return option.disabled;
        },
        clearable: clearable,
        onChange: this.onChangeCurrency,
        options: currencyCodes,
        value: this.getCurrencyValue(currencyCodes)
      }, rest));
    }
  }]);

  return CurrencySelector;
}(PureComponent);

_defineProperty(CurrencySelector, "propTypes", {
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  currency: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  disabled: PropTypes.bool,
  disabledCurrencies: PropTypes.arrayOf(PropTypes.string),
  isMulti: PropTypes.bool,
  label: PropTypes.string,
  required: PropTypes.bool,
  displayFullName: PropTypes.bool,
  clearable: PropTypes.bool
});

_defineProperty(CurrencySelector, "defaultProps", {
  disabled: false,
  disabledCurrencies: [],
  className: '',
  required: false,
  displayFullName: false,
  clearable: false,
  currency: null,
  label: 'Currency'
});

export default CurrencySelector;